// extracted by mini-css-extract-plugin
module.exports = {"container":"_3pb0VmR4hbgLWJGFDoJP2u","visible":"_2gl1oaPeVlJk6yOaBDbAVG","cancelBtn":"_2-qJkLcPP8is7iDKkT2Qlu","icon":"_1zkNcK-7MpRSguDVhaZ5ld","saveBtn":"paazjKRs8mPOXqoxsMQt4"};